export default __webpack_public_path__ + "static/media/menu_settings_icon.39ffd46e.svg";